import {Model, ARRAY_SHAPE} from 'vias';
import _ from 'lodash';
import http from 'sp-components/util/http';
import {routes, url} from 'oo-routes';
import {restResponseCb} from '../util';

export default new Model('Product', {
  id: '_id',
}, {
  get: function (alias, key, options, cb) {
    http.get(url('print', routes.print.products.detail, {identifier: key}), restResponseCb(cb));
  },
},{
  search: {
    shape: ARRAY_SHAPE,
    action: function(query, options, cb) {
      http.get(url('print', routes.print.v3.products.search, query), restResponseCb(cb));
    },
  },
});



// WEBPACK FOOTER //
// ./~/sp-components/models/Product.js